import type { Context } from 'react';
import { createContext } from 'react';

type FeedContextType = {
	feedSessionId: string | null;
};

export const FeedContext: Context<FeedContextType> = createContext<FeedContextType>({
	feedSessionId: null,
});
